import AuthenticationContext from 'adal-angular/lib/adal.js'

const config = {
  tenant: '6d99bc28-8f28-4a73-a501-63a8e1eb3040',
  clientId: '4836a587-dab3-4a5f-ac87-eb38b182ca1b',
  cacheLocation: 'localStorage',
  postLogoutRedirectUri: window.location.origin
}

export default {
  authenticationContext: null,
  /**
   * @return {Promise}
   */
  initialize () {
    this.authenticationContext = new AuthenticationContext(config)

    return new Promise((resolve, reject) => {
      if (this.authenticationContext.isCallback(window.location.hash) || window.self !== window.top) {
        // redirect to the location specified in the url params.
        this.authenticationContext.handleWindowCallback()
      } else {
        // try pull the user out of local storage
        let user = this.authenticationContext.getCachedUser()

        if (user) {
          resolve()
        } else {
          // no user at all - go sign in.
          this.signIn()
        }
      }
    })
  },
  /**
   * @return {Promise.<String>} A promise that resolves to an ADAL token for resource access
   */
  acquireToken () {
    return new Promise((resolve, reject) => {
      this.authenticationContext.acquireToken('<azure active directory resource id>', (error, token) => {
        if (error || !token) {
          return reject(error)
        } else {
          return resolve(token)
        }
      })
    })
  },
  /**
   * Issue an interactive authentication request for the current user and the api resource.
   */
  acquireTokenRedirect () {
    this.authenticationContext.acquireTokenRedirect('<azure active directory resource id>')
  },
  /**
   * @return {Boolean} Indicates if there is a valid, non-expired access token present in localStorage.
   */
  isAuthenticated () {
    return true
    // getCachedToken will only return a valid, non-expired token.
    // if (this.authenticationContext.getCachedToken(config.clientId)) { return true }
    // return false
  },
  /**
   * @return An ADAL user profile object.
   */
  getUserProfile () {
    return this.authenticationContext.getCachedUser().profile
  },
  signIn () {
    this.authenticationContext.login()
  },
  signOut () {
    this.authenticationContext.logOut()
  }
}



// WEBPACK FOOTER //
// ./src/auth/index.js